// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_n0-0";
export var discountCodeInput = "_n0-1";